import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MaterialProductGroupsService} from '../material-product-groups.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {
  MaterialProductGroup,
  MaterialProductGroupForm,
  MaterialProductGroupFormValue
} from '../material-product-groups.models';
import {HttpErrorResponse} from '@angular/common/http';
import {AlertService} from '../../../../common/alert-service/alert.service';

@Component({
    selector: 'material-product-groups-edit-modal',
    templateUrl: './material-product-groups-edit-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaterialProductGroupsEditModalComponent implements OnInit {
  @Input() productGroup: MaterialProductGroup;
  form: FormGroup<MaterialProductGroupForm>;
  errors: {[key: string]: any} = {};
  constructor(private service: MaterialProductGroupsService,
              private modalRef: NgbActiveModal,
              private alertService: AlertService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: new FormControl<string>(this.productGroup.name, [Validators.required]),
    } as MaterialProductGroupForm);
  }

  save(): void {
    this.errors = {};
    this.service.update(this.productGroup.id, this.form.value as MaterialProductGroupFormValue).subscribe(() => {
      this.modalRef.close();
    }, (error: HttpErrorResponse) => {
      this.errors = error.error.errors ?? {};
      if (error.status === 409) {
        this.alertService.add('danger', 'Es existiert bereits eine Produkt Gruppe mit diesem Namen');
      }
    });
  }

  close(): void {
    this.modalRef.dismiss();
  }
}
